import React from 'react';

const QuestionOptions = ({ options, selectedOption, onSelect }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4">
      {options.map((option, index) => (
        <button
          key={index}
          onClick={() => onSelect(option)}
          className={`group relative p-6 rounded-lg border-2 transition-all duration-300 transform hover:scale-105 ${
            selectedOption === option.value
              ? 'border-[#FFD700] bg-[#FFD700]/10 shadow-lg shadow-[#FFD700]/30'
              : 'border-gray-700 bg-gray-900/50 hover:border-[#FFD700] hover:bg-[#FFD700]/5'
          }`}
        >
          {/* Glow effect on hover */}
          <div className="absolute inset-0 rounded-lg bg-[#FFD700]/0 group-hover:bg-[#FFD700]/5 transition-all duration-300" />
          
          <div className="relative z-10">
            <p className={`text-left text-base md:text-lg transition-colors duration-300 ${
              selectedOption === option.value
                ? 'text-[#FFD700] font-semibold'
                : 'text-white group-hover:text-[#FFD700]'
            }`}>
              {option.label}
            </p>
          </div>

          {/* Selected indicator */}
          {selectedOption === option.value && (
            <div className="absolute top-3 right-3 w-6 h-6 bg-[#FFD700] rounded-full flex items-center justify-center animate-scale-in">
              <svg
                className="w-4 h-4 text-black"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M5 13l4 4L19 7" />
              </svg>
            </div>
          )}
        </button>
      ))}
    </div>
  );
};

export default QuestionOptions;